import {
  Card,
  Chart,
  CurrencyValue,
  formatNumber,
  Text,
  Heading
} from '@blockanalitica/ui';
import { ChartConfig } from '@blockanalitica/ui/package/types/src/components/charts/Chart';
import { useCallback, useMemo } from 'react';
import { useTheme } from 'styled-components';

const DISTRIBUTION_DATA = [
  { year: 1, cumulative_total: 1625000000, amount: 1625000000 },
  { year: 2, cumulative_total: 3250000000, amount: 1625000000 },
  { year: 3, cumulative_total: 4062500000, amount: 812500000 },
  { year: 4, cumulative_total: 4875000000, amount: 812500000 },
  { year: 5, cumulative_total: 5281250000, amount: 406250000 },
  { year: 6, cumulative_total: 5687500000, amount: 406250000 },
  { year: 7, cumulative_total: 5890625000, amount: 203125000 },
  { year: 8, cumulative_total: 6093750000, amount: 203125000 },
  { year: 9, cumulative_total: 6296875000, amount: 203125000 },
  { year: 10, cumulative_total: 6500000000, amount: 203125000 }
];

export default function SPKDistributionChart({ ...rest }) {
  const theme = useTheme();
  const datasets = useMemo(() => {
    const series = [
      {
        label: 'Cumulative',
        backgroundColor: theme.colors.sparkSavingsColor,
        borderColor: theme.colors.sparkSavingsColor,
        type: 'line',
        data: DISTRIBUTION_DATA.map((row) => ({
          x: row.year,
          y: row.cumulative_total
        }))
      },
      {
        label: 'Yearly',
        backgroundColor: theme.colors.spark.purple8,
        borderColor: theme.colors.spark.purple8,
        type: 'bar',
        data: DISTRIBUTION_DATA.map((row) => ({
          x: row.year,
          y: row.amount
        }))
      }
    ];

    return series;
  }, [theme.colors]);

  const config: ChartConfig = useMemo(() => {
    return {
      options: {
        scales: {
          x: {
            type: 'linear'
          }
        }
      }
    };
  }, []);

  const valueFormatter = useCallback((value: string | number) => {
    return <CurrencyValue value={value} />;
  }, []);

  const xScaleValueFormatter = useCallback((value: string | number) => {
    return `Year ${value}`;
  }, []);

  const yScaleValueFormatter = useCallback((value: string | number) => {
    return formatNumber(Number(value));
  }, []);

  return (
    <Card flexDirection="column" gap="s" {...rest}>
      <Heading size="4">Genesis Farming Emission Schedule</Heading>
      <Text color="muted" fontSize="-1">
        The SPK emissions follow the rules set forth in the Sky Atlas, which
        states that 10 billion SPK tokens will be emitted over the first 10
        years. 6.5 billion tokens are emitted through Genesis farming, which
        gradually decreases over time, and 3.5 billion tokens are allocated to
        the Spark Foundation.
      </Text>

      <Chart
        chartDatasets={datasets}
        config={config}
        xScaleValueFormatter={xScaleValueFormatter}
        yScaleValueFormatter={yScaleValueFormatter}
        subValueFormatter={xScaleValueFormatter}
        valueFormatter={valueFormatter}
      />
    </Card>
  );
}
